module.exports = __webpack_public_path__ + "static/media/Kopie-von-Kopie-von-Kopie-von-IMG_4806.b4a89366.jpeg";